webpackJsonp([162540808437212],{

/***/ 1437:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"EventsOrderBy","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"insertedAt","type":{"kind":"ENUM","name":"OrderByDirection","ofType":null}},{"defaultValue":null,"description":null,"name":"type","type":{"kind":"ENUM","name":"OrderByDirection","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-events-order-by-9e1594ddd9d2b5181265.js